import { render, staticRenderFns } from "./header-layout.vue?vue&type=template&id=5c9b4522&scoped=true"
import script from "./header-layout.vue?vue&type=script&lang=js"
export * from "./header-layout.vue?vue&type=script&lang=js"
import style0 from "./header-layout.vue?vue&type=style&index=0&id=5c9b4522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b4522",
  null
  
)

export default component.exports